var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: function value() {
        return _vm.isShowMenuCategory = false;
      },
      expression: "() => (isShowMenuCategory = false)"
    }],
    staticClass: "header_box"
  }, [_c("div", [_c("div", [_c("div", {
    class: ["header"]
  }, [_c("div", {
    staticClass: "navitems",
    style: {
      "--menuHoverColor": _vm.formData.hoverTextColor,
      backgroundColor: _vm.formData.bgColor,
      "--titleSpace": _vm.formData.titleSpace + "px",
      fontSize: _vm.formData.fontSize + "px",
      color: _vm.formData.textColor
    }
  }, [_c("div", {
    staticClass: "navitems_content common_content"
  }, [_c("dd", [_vm.formData.categoryStatus ? _c("dl", {
    ref: "all_product",
    style: {
      marginRight: _vm.formData.titleSpace + "px"
    },
    on: {
      click: function click() {
        return _vm.isShowMenuCategory = !_vm.isShowMenuCategory;
      }
    }
  }, [_c("i", {
    staticClass: "yy-icon-Access"
  }), _c("span", {
    staticClass: "allProductTitle"
  }, [_vm._v(_vm._s(_vm.formData.categoryTitle[_vm.defaultLangId]))]), _c("i", {
    staticClass: "yy-icon-ArrowDown1"
  }), _vm.formData.categoryStatus ? _c("dl", {
    staticClass: "dl",
    style: {
      marginLeft: "30px"
    }
  }) : _vm._e()]) : _vm._e(), [_vm._l(_vm.beforeArr, function (item, key) {
    return _c("dl", {
      key: "navigations_item" + key,
      style: {
        marginRight: _vm.formData.titleSpace + "px"
      }
    }, [_c("a", [_vm._v(_vm._s(item.title[_vm.defaultLangId]))])]);
  }), _c("div", {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: function value() {
        return _vm.more_visible = false;
      },
      expression: "() => more_visible = false"
    }],
    ref: "moreNavigations",
    staticClass: "more_label",
    staticStyle: {
      "white-space": "nowrap"
    },
    style: {
      opacity: _vm.isShowMoreLabel ? 1 : 0,
      pointerEvents: _vm.isShowMoreLabel ? "auto" : "none"
    }
  }, [_c("dl", {
    on: {
      click: function click($event) {
        _vm.more_visible = !_vm.more_visible;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("header.more")) + " "), _c("i", {
    staticClass: "yy-icon-ArrowDown1"
  })]), _c("div", {
    staticClass: "moreVisible",
    style: {
      opacity: _vm.more_visible ? 1 : 0,
      pointerEvents: _vm.isShowMoreLabel ? "auto" : "none"
    }
  }, _vm._l(_vm.afterArr, function (item, key) {
    return _c("div", {
      key: "navigations_more" + key,
      staticClass: "more-item",
      staticStyle: {
        "line-height": "40px"
      }
    }, [_c("a", [_vm._v(_vm._s(item.title[_vm.defaultLangId]))])]);
  }), 0)])]], 2)])])])])]), _vm.isShowMenuCategory ? _c("menu-category", {
    staticClass: "js-menucategory",
    attrs: {
      formData: _vm.formData
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };